import React, { useCallback } from 'react'

import { connect } from 'react-redux'

import * as Styled from '@chegg-wt/core/components/Folders/shared/FolderSettingsMenu/styled'

import { FolderSettingsProps } from '@chegg-wt/core/components/Folders/shared/FolderSettingsMenu/types'
import { DELETE_MODAL, EDIT_FOLDER_MODAL } from '@chegg-wt/core/state/modals/constants'
import { openModal } from '@chegg-wt/core/state/modals/actions'

export const FolderSettingsMenu: React.FunctionComponent<FolderSettingsProps> = ({
  index,
  closeMenu,
  editFolder,
  deleteFolder,
  className = '',
}) => {
  const handleEditClick = useCallback(() => {
    editFolder(index)
    closeMenu()
  }, [editFolder, index, closeMenu])
  const handleDeleteClick = useCallback(() => {
    deleteFolder(index)
    closeMenu()
  }, [deleteFolder, index, closeMenu])
  return (
    <Styled.SettingsMenu className={className}>
      <Styled.SettingsMenuItem>
        <Styled.SettingAction
          type="button"
          onClick={handleEditClick}
          data-test={`edit-folder-${index}`}
        >
          Edit
        </Styled.SettingAction>
      </Styled.SettingsMenuItem>
      <Styled.SettingsMenuItem>
        <Styled.SettingAction
          type="button"
          onClick={handleDeleteClick}
          data-test={`delete-folder-${index}`}
        >
          Delete
        </Styled.SettingAction>
      </Styled.SettingsMenuItem>
    </Styled.SettingsMenu>
  )
}

const mapFolderSettingsDispatchToProps = {
  editFolder: (index) => openModal({ name: EDIT_FOLDER_MODAL, data: { index } }),
  deleteFolder: (index) =>
    openModal({
      name: DELETE_MODAL,
      data: {
        index,
        resourceType: 'folder',
      },
    }),
}

export default connect(null, mapFolderSettingsDispatchToProps)(FolderSettingsMenu)
